export type PrintSettings = {
  paper: 'a4';
  orientation: 'auto' | 'portrait' | 'landscape';
  imageFit: 'content' | 'page';
};

export const DEFAULT_PRINT_SETTINGS: PrintSettings = { paper: 'a4', orientation: 'auto', imageFit: 'content' };
